module.exports = __webpack_public_path__ + "static/media/car-sell.5e7d7c0a.png";